import { Component, Input } from '@angular/core';
import { SelectableJob } from '../select-jobs-grid/select-job.models';
import { SelectJobsSummaryService } from './select-jobs-summary.service';

@Component({
    selector: 'cdp-select-jobs-summary',
    templateUrl: './select-jobs-summary.component.html',
    styleUrls: ['./select-jobs-summary.component.scss'],
    standalone: false
})
export class SelectJobsSummaryComponent {
    @Input() jobs: SelectableJob[];
    @Input() scheduleId: number;
    constructor(private service: SelectJobsSummaryService) {}
    public get jobsToReassign(): number {
        return this.service.getJobsToReassign(this.jobs, this.scheduleId);
    }
    public get jobsAlreadyAssigned(): number {
        return this.service.getJobsAlreadyAssigned(this.jobs, this.scheduleId);
    }
    public get jobsToAdd(): number {
        return this.service.getJobsToAdd(this.jobs);
    }
    public get selectedJobCountStr(): string {
        return this.service.getSelectedJobCountStr(
            this.scheduleId,
            this.jobsToAdd,
            this.jobsToReassign,
            this.jobsAlreadyAssigned
        );
    }
    public get selectedJobCountTooltip(): string {
        return this.service.getSelectedJobCountTooltip(this.jobsToAdd, this.jobsToReassign, this.jobsAlreadyAssigned);
    }
}
